import styled, { css } from 'styled-components';
import { fromMd } from '../../constants';
import { Button } from '../Button';
import { IconButton } from '../IconButton';
export const PaginationWrapper = styled.div `
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  margin: 20px -10px 30px;

  ${fromMd} {
    margin: 20px -30px 30px;
  }
`;
export const CaretButton = styled(IconButton) `
  flex-shrink: 0;
  margin: 0 10px;
  outline: none;
  padding: 10px;

  svg path {
    stroke: ${o => o.theme.color.deprecated.obsidian};
  }

  &:hover {
    svg path {
      stroke: ${o => o.theme.color.deprecated.obsidianLighter};
    }
  }

  &:disabled {
    cursor: default;

    svg path {
      stroke: ${o => o.theme.color.deprecated.stoneDark};
    }
  }

  .rtl & {
    transform: scaleX(-1);
  }
`;
export const PageNumberLink = styled.a `
  color: ${o => o.isSelected ? o.theme.color.deprecated.obsidianLighter : o.theme.color.deprecated.stoneDark};
  cursor: ${o => (o.isSelected ? 'default' : 'pointer')};
  display: inline-block;
  font-size: 14px;
  font-weight: ${o => o.isSelected && 'bold'};

  &:hover {
    color: ${o => o.theme.color.deprecated.obsidianLighter};
  }
`;
export const PageNumberButton = styled(Button) `
  border-color: ${o => !o.isSelected && o.theme.color.deprecated.stoneDark};
  border-width: 1px;
  padding: 0 16px;
`;
export const PageNumbersWrapper = styled.div `
  flex-shrink: 30;
  overflow: hidden;
  text-overflow: ellipsis;
  width: auto;

  ${o => o.useFilledButtons &&
    css `
      display: flex;
      gap: 8px;
    `}

  ${PageNumberLink} {
    padding: 10px 5px;
  }

  ${fromMd} {
    ${PageNumberLink} {
      padding: 10px;
    }
  }
`;
//# sourceMappingURL=styles.js.map